import React, { useLayoutEffect, useState } from 'react';

import { ItemGroupProps } from 'types/ItemGroupProps';
import * as S from './styles';

interface DescriptionProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

export default function Description({ data, phoneWidth }: DescriptionProps) {
  const [fontWeight, setFontWeight] = useState(300);

  useLayoutEffect(() => {
    if (data.reference_id) {
      const weight: any = parseInt(data.reference_id, 10);

      if (typeof weight === 'number') {
        setFontWeight(weight);
      }
    }
  }, []);

  return (
    <S.container fontWeight={fontWeight}>
      <b>{data.name || 'No name'} </b>
      <p>{data.description || 'No name'}</p>
    </S.container>
  );
}
